/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.publicQrCodeScan.internal

import features.publicQrCodeScan.models.PublicQrCodeScanResponseModel
import features.publicQrCodeScan.models.ScanPublicQrCodeRequest
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class ScanningPublicQrCodeRequest : NetworkRequest() {

    suspend fun scanPublicQrCode(
        overrideHeaders: Map<String, String>? = null,
        scanPublicQrCodeRequest: ScanPublicQrCodeRequest
    ): IOResult<PublicQrCodeScanResponseModel> {
        return safeNetworkCall {
            post<PublicQrCodeScanResponseModel, ScanPublicQrCodeRequest>(
                endpoint = ScanningPublicQrCodeEndpoint,
                requestBody = scanPublicQrCodeRequest,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
